import React from "react";
import gridIcon from "../../../../assets/img/grid1.svg";
import listIcon from "../../../../assets/img/grid.svg";
import ReactTooltip from "react-tooltip";
import { useClipboard } from "./ImageClipboardProvider";
import ImageSortControls from "./ImageSortControls";

const MasterFilter = ({
    setGridView,
    isGridView = true,
    selectedImages,
    handleSelectAll,
    handleClearAll,
    allSelected,
    exportImagesZip = null,
    exportImageZipLoader,
    isAsset,
    onEditCaption,
    hasExport,
    hasEdit,
    hasBulkDelete = false,
    onBulkDelete,
    hasImageCopyPaste,
    onCopyImage,
    onPasteImage,
    canPaste,
    imageList,
    showImageSort = false,
    sortFieldOptions = [],
    sortField = "",
    sortOrder = "desc",
    onSortFieldChange,
    onSortOrderChange,
    sortDisabled = false
}) => {
    const { clip, clear } = useClipboard();
    const zipExportError = selectedImages?.length > 500 ? "Please select a maximum of 500 images" : "";
    return (
        <div className="nav-fil-top">
            <div className="top-bar sort-otr mb-2 p-0">
                <div className="left-control">
                    {(hasExport || hasEdit) && imageList?.length > 0 && (
                        <div className="btn">
                            <label className="container-check">
                                <input type="checkbox" checked={allSelected} onClick={handleSelectAll} />
                                <span className="checkmark"></span>
                                {`Select All ${selectedImages?.length ? `(${selectedImages.length})` : ""}`}
                            </label>
                        </div>
                    )}
                    {selectedImages?.length > 0 && (
                        <>
                            <button className="btn btn-edit" onClick={handleClearAll}>
                                <i className="fas fa-times-circle"></i>
                                Clear All
                            </button>
                            {exportImagesZip && hasExport && (
                                <button
                                    className={`btn btn-edit ${zipExportError ? "cursor-diabled" : ""}`}
                                    data-tip={zipExportError}
                                    data-place="bottom"
                                    data-effect="solid"
                                    data-background-color="#007bff"
                                    onClick={() => (!zipExportError ? exportImagesZip(selectedImages) : undefined)}
                                >
                                    {!exportImageZipLoader ? (
                                        <i class="fas fa-file-archive"></i>
                                    ) : (
                                        <div className="edit-icn-bx icon-btn-sec d-inline-block mr-1">
                                            <div className="spinner-border" role="status"></div>
                                        </div>
                                    )}
                                    Download <span>{selectedImages?.length} </span> (zip)
                                </button>
                            )}
                            <ReactTooltip />

                            {hasEdit && (
                                <button type="button" className="btn btn-edit" onClick={onEditCaption}>
                                    Edit Caption{" "}
                                </button>
                            )}
                            {hasBulkDelete && (
                                <button type="button" className="btn btn-edit" onClick={() => onBulkDelete(selectedImages)}>
                                    Delete
                                </button>
                            )}
                            {hasImageCopyPaste && (
                                <>
                                    <button type="button" className="btn btn-edit" onClick={onCopyImage}>
                                        <i class="fas fa-copy"></i> Copy Images ({selectedImages?.length})
                                    </button>
                                </>
                            )}
                        </>
                    )}
                    {hasImageCopyPaste && canPaste && (
                        <>
                            <button type="button" className="btn btn-edit" onClick={onPasteImage}>
                                <i class="fas fa-paste"></i> Paste Images ({clip.itemIds?.length})
                            </button>
                            <button type="button" className="btn btn-edit" onClick={clear}>
                                <i class="fas fa-minus-square"></i>Clear Copied Images
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="top-bar icon-bar info-image-toolbar-wrap d-flex align-items-center">
                <div className="info-image-toolbar-right">
                    {showImageSort && (
                        <ImageSortControls
                            sortFieldOptions={sortFieldOptions}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSortFieldChange={onSortFieldChange}
                            onSortOrderChange={onSortOrderChange}
                            sortDisabled={sortDisabled}
                        />
                    )}
                    <div className="info-image-view-toggle" role="group" aria-label="View mode">
                        <button
                            type="button"
                            className={`info-image-view-toggle-btn${!isGridView ? " is-active" : ""}`}
                            data-tip="List View"
                            onClick={() => setGridView(false)}
                            aria-label="List view"
                            aria-pressed={!isGridView}
                        >
                            <img src={listIcon} alt="" />
                        </button>
                        <button
                            type="button"
                            className={`info-image-view-toggle-btn${isGridView ? " is-active" : ""}`}
                            data-tip="Grid View"
                            onClick={() => setGridView(true)}
                            aria-label="Grid view"
                            aria-pressed={isGridView}
                        >
                            <img src={gridIcon} alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <ReactTooltip id="master-img-filter" effect="solid" backgroundColor="#1383D9" />
        </div>
    );
};

export default MasterFilter;
